import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

export default function getAge(dateString) {
  const totalDiff = dayjs.duration(dayjs().diff(dayjs(dateString)));

  return totalDiff.years() > 0 ? totalDiff.years() + " years" : totalDiff.months() + " months";
}